import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavbarComponent } from './side-navbar.component';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [SideNavbarComponent],
  imports: [CommonModule, RouterModule],
  exports: [SideNavbarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SideNavBarModule {}
